import React, { useEffect } from "react";
import "./App.css";

import { Container, Row, Col } from "react-bootstrap";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { useDispatch } from "react-redux";

import NavigationBar from "./components/NavigationBar";
import Welcome from "./components/Welcome";
import Book from "./components/Book/Book";
import BookList from "./components/Book/BookList";
import UserList from "./components/User/UserList";
import TradeList from "./components/Trade/TradeList";
import MTMReport from "./components/MTM/MtmReport";
import StockChart from "./components/Chart/StockChart";
import DailyTradeList from "./components/DailyTrade/DailyTradeList";
import DailyReport from "./components/Report/DailyReport";
import Register from "./components/User/Register";
import Login from "./components/User/Login";
import Home from "./components/Home";
import MarketDataComparison from "./components/MarketData/MarketDataComparison";
import IndexAnalysisComparison from "./components/MarketData/IndexAnalysisComparison";
import B10CEAnalyzer from "./components/ExitAnalyzer/B10CEAnalyzer";
import ExitItemsBrowser from "./components/ExitItemsBrowser/ExitItemsBrowser";
import EntryDataPointBrowser from "./components/EntryDataPointBrowser/EntryDataPointBrowser";
import ExitSnapshotView from "./components/ExitSnapshot/ExitSnapshotView";
import EntrySnapshotView from "./components/EntrySnapshot/EntrySnapshotView";
import MlDashboard from "./components/MlDashboard/MlDashboard";
import { ProtectedRoute, AdminRoute, Unauthorized } from "./components/ProtectedRoute";
import { initializeAuth, validateToken } from "./services/user/auth/authActions";

const EntryFirst45View = () => <EntrySnapshotView mode="first45" />;
const EntryLastHourView = () => <EntrySnapshotView mode="lastHour" />;

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Initialize auth header on app load
    initializeAuth();
    // Validate existing token
    dispatch(validateToken()).catch(() => {
      // Token validation failed, user will need to login
    });
  }, [dispatch]);

  window.onbeforeunload = (event) => {
    const e = event || window.event;
    e.preventDefault();
    if (e) {
      e.returnValue = "";
    }
    return "";
  };

  return (
    <Router>
      <div className="app-layout">
        <NavigationBar />
        <main className="app-main">
          <Container fluid className="main-container">
            <Row>
              <Col lg={12} className={"margin-top"}>
                <Switch>
              {/* Public Routes */}
              <Route path="/trade_app/" exact component={Welcome} />
              <Route path="/trade_app/login" exact component={Login} />
              <Route path="/trade_app/register" exact component={Register} />
              <Route path="/trade_app/unauthorized" exact component={Unauthorized} />
              <Route
                path="/logout"
                exact
                component={() => (
                  <Login message="User Logged Out Successfully." />
                )}
              />

              {/* Protected Routes - Any authenticated user */}
              <ProtectedRoute path="/trade_app/home" exact component={Home} />
              <ProtectedRoute path="/trade_app/trades" exact component={TradeList} />
              <ProtectedRoute path="/trade_app/dailyTrades" exact component={DailyTradeList} />
              <ProtectedRoute path="/trade_app/Chart" exact component={StockChart} />
              <ProtectedRoute path="/trade_app/mtmReport" exact component={MTMReport} />
              <ProtectedRoute path="/trade_app/marketDataCompare" exact component={MarketDataComparison} />
              <ProtectedRoute path="/trade_app/indexAnalysisCompare" exact component={IndexAnalysisComparison} />
              <ProtectedRoute path="/trade_app/exitAnalyzer" exact component={B10CEAnalyzer} />
              <ProtectedRoute path="/trade_app/exitItemsBrowser" exact component={ExitItemsBrowser} />
              <ProtectedRoute path="/trade_app/entryDataPointBrowser" exact component={EntryDataPointBrowser} />
              <ProtectedRoute path="/trade_app/exitSnapshot" exact component={ExitSnapshotView} />
              <ProtectedRoute path="/trade_app/entryFirst45" exact component={EntryFirst45View} />
              <ProtectedRoute path="/trade_app/entryLastHour" exact component={EntryLastHourView} />
              <Route path="/trade_app/mlDashboard" exact component={MlDashboard} />
              <ProtectedRoute path="/trade_app/add" exact component={Book} />
              <ProtectedRoute path="/trade_app/edit/:id" exact component={Book} />
              <ProtectedRoute path="/trade_app/list" exact component={BookList} />

              {/* Admin Only Routes */}
              <AdminRoute path="/trade_app/report" exact component={DailyReport} />
              <AdminRoute path="/trade_app/users" exact component={UserList} />
                </Switch>
              </Col>
            </Row>
          </Container>
        </main>
      </div>
    </Router>
  );
};

export default App;
